import { IconProps } from '../icons';
import { themeColors } from '@styles/theme';

export const AddPresetLayerIcon = ({
    width = 24,
    height = 24,
    color = themeColors.grey,
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 4L20 8L12 12L4 8L12 4Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path d="M4 12L12 16L20 12" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
            <path
                d="M10.4 6.6V11.0
       M10.4 6.6H12.1
       C13.1 6.6 13.7 7.1 13.7 7.9
       C13.7 8.7 13.1 9.2 12.1 9.2H10.4"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
